import { FC } from 'react';
import { Link } from 'react-router-dom';
import classes from '../../asset/css/subscription-detail/menu.module.css';

export const Menu: FC = () => {
  return (
    <div className={classes.menu}>
      <ul className={classes.menu_list}>
        <li className={classes.menu_item}>
          <a href={`${document.referrer.replace(/\/$/, '')}/pages/account`} target="_parent" className={classes.menu_link}>
            購入履歴
          </a>
        </li>
        <li className={classes.menu_item}>
          <a href={`${document.referrer.replace(/\/$/, '')}/pages/account-edit`} target="_parent" className={classes.menu_link}>
            お客様情報の変更
          </a>
        </li>
        <li className={classes.menu_item}>
          <Link to="/shippingAddress/form" className={classes.menu_link}>
            お届け先情報の変更
          </Link>
        </li>
        <li className={classes.menu_item}>
          <Link to="/paymentMethod" className={classes.menu_link}>
            支払い方法を変更
          </Link>
        </li>
        <li className={classes.menu_item}>
          <Link to="/cancel" className={classes.menu_link}>
            XOULFUL BOXを解約
          </Link>
        </li>
        <li className={classes.menu_item}>
          <a href={`${document.referrer.replace(/\/$/, '')}/account/logout`} target="_parent" className={classes.menu_link}>
            ログアウト
          </a>
        </li>
      </ul>
    </div>
  );
};
